import { render, staticRenderFns } from "./WatchedButton.vue?vue&type=template&id=c1e7a97e&"
import script from "./WatchedButton.vue?vue&type=script&lang=js&"
export * from "./WatchedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports